import { Component } from '@angular/core';
import { SupprotsAIHelpDesk } from "../supprots-ai-help-desk/supprots-ai-help-desk";

@Component({
  selector: 'app-support-desk',
  imports: [SupprotsAIHelpDesk],
  templateUrl: './support-desk.html',
  styleUrl: './support-desk.css',
})
export class SupportDesk {

}


